export const GetContentTypeByFileName = paramUrl => {
  const FileExtensions_Image = "jpg|jpeg|tiff|gif|bmp|svg|png|webp|avif";
  const FileExtensions_Sound = "3gp|m4a|m4b|m4p|mp3|raw|wma|webm|wav|ogg";
  const FileExtensions_Document = "html|html|doc|docx|xls|xlsx|ppt|pptx|rtf|odt";
  const FileExtensions_Video = "mkv|flv|vob|ogg|avi|mov|wmv|mpg|m4v|mp4|3gp|ogv";
  const FileExtensions_PDF = "pdf";
  let contentType = paramUrl.substring(paramUrl.lastIndexOf(".") + 1).toLowerCase();
  if (FileExtensions_Video.includes(contentType)) {
    contentType = `video/${contentType}`;
  } else if (FileExtensions_Sound.includes(contentType)) {
    contentType = `audio/${contentType}`;
  } else if (FileExtensions_Image.includes(contentType)) {
    contentType = `image/${contentType}`;
  } else if (FileExtensions_Document.includes(contentType) || FileExtensions_PDF.includes(contentType)) {
    contentType = `application/${contentType}`;
  } else {
    contentType = "none";
  }
  return contentType;
};